<template>
  <ECommonProductAdsCarousel
    :items="items"
    :tooltip-side="tooltipSide"
    :shopping-url="shoppingUrl"
    :full-width-variant="hasFullWidthProductAds"
    :first-hidden-item-index="firstHiddenItemIndex"
    @item-click="onItemClick"
    @hidden-items-visible="onHiddenItemsVisible"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { PRIVACY_PROXY_MS } from '~~/common/js/constants/feature-flags';
import { getUrlQuery } from '~~/common/js/universal/search';
import screen from '~~/common/vue/mixins/screen';
import ECommonProductAdsCarousel from '~~/search/common/vue/components/product-ads/carousel';
import sendVisibilityFeedback, { VISIBILITY_FEEDBACK_THRESHOLD } from '~/trackers/visibility-feedback';

export default {
  name: 'EProductAdsCarousel',
  components: {
    ECommonProductAdsCarousel,
  },
  mixins: [screen()],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    items: {
      ...ECommonProductAdsCarousel.props.items,
      default: () => [],
    },
    hasFullWidthProductAds: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['bingTracking']),
    ...mapGetters(['hasShoppingLink']),
    ...mapGetters('goodall', ['getExperiment']),
    shoppingUrl() {
      if (!this.hasShoppingLink) {
        return '';
      }
      const query = getUrlQuery(this.$route.query, this.$store.state.user);
      return this.$router.resolve({ path: '/shopping', query }).href;
    },
    tooltipSide() {
      return this.isDesktopUp ? 'right-center' : 'right-bottom';
    },
    // src/trackers/impression-feedback.js for an explanation
    firstHiddenItemIndex() {
      return this.bingTracking ? VISIBILITY_FEEDBACK_THRESHOLD : null;
    },
    shouldProxyTracking() {
      return this.getExperiment(PRIVACY_PROXY_MS.flag)?.includes(PRIVACY_PROXY_MS.enabled);
    },
  },
  methods: {
    ...mapActions(['trackAdClick']),
    onItemClick({ pingSuffix }) {
      this.trackAdClick(pingSuffix, this.shouldProxyTracking);
    },
    onHiddenItemsVisible(items) {
      if (!this.bingTracking) {
        return;
      }
      const ids = items.map(({ trackingId }) => trackingId).filter(Boolean);
      sendVisibilityFeedback(ids, this.bingTracking, this.shouldProxyTracking);
    },
  },
};
</script>
